import { FC } from 'react';
import {
  CapitalStructureEventFaults,
  CapitalStructureInstrumentDefinitionDto,
} from '@app/shared/models/contracts/capital-structure-debt-instrument-dto';
import { CapitalStructureEventSeverity } from '@app/shared/models/contracts/enums/shared-enums';
import FaultIcon from './FaultIcon';
import SvgEventInformation from '@app/shared/icons/EventInformation';
import SvgWarningStatus from '@app/shared/icons/WarningStatus';
import SvgExclamationMarkCircled from '@app/shared/icons/ExclamationMarkCircled';

interface CapitalStructureFaultsProps {
  informationFaults: CapitalStructureEventFaults[];
  warningFaults: CapitalStructureEventFaults[];
  errorFaults: CapitalStructureEventFaults[];
  instrumentDefinitions: Record<string, CapitalStructureInstrumentDefinitionDto>;
  isWithinEditEventModal?: boolean;
}

const CapitalStructureFaults: FC<CapitalStructureFaultsProps> = ({
  informationFaults,
  warningFaults,
  errorFaults,
  instrumentDefinitions,
  isWithinEditEventModal = false,
}) => {
  return (
    <>
      <FaultIcon
        severity={CapitalStructureEventSeverity.Information}
        icon={<SvgEventInformation />}
        label="_Information"
        eventFaults={informationFaults}
        instrumentDefinitions={instrumentDefinitions}
        isWithinEditEventModal={isWithinEditEventModal}
      />
      <FaultIcon
        severity={CapitalStructureEventSeverity.Warning}
        icon={<SvgWarningStatus />}
        label="_Warnings"
        eventFaults={warningFaults}
        instrumentDefinitions={instrumentDefinitions}
        isWithinEditEventModal={isWithinEditEventModal}
      />
      <FaultIcon
        severity={CapitalStructureEventSeverity.Error}
        icon={<SvgExclamationMarkCircled />}
        label="_Errors"
        eventFaults={errorFaults}
        instrumentDefinitions={instrumentDefinitions}
        isWithinEditEventModal={isWithinEditEventModal}
      />
    </>
  );
};

export default CapitalStructureFaults;
